import React, { FC, useState, useContext } from "react";
import { observer } from "mobx-react-lite";
import { Context } from "../../index";

interface User {
 username: string;
 role: string;
}

const Header: FC = () => {
 const [isShowCategory, setIsShowCategory] = useState<any>(false);
 const [categoryPost, setCategoryPost] = useState<any>("EN");
 const { store } = useContext(Context);
 const user: User = store.user;

 const handleShowCategories = () => {
  setIsShowCategory(!isShowCategory);
 };
 const handleChooseCategories = (e: any) => {
  setCategoryPost(e.target.innerText);
  setIsShowCategory(!isShowCategory);
 };
 return (
  <header>
   <div className="topbar d-flex align-items-center justify-content-end">
    <div className="d-flex align-items-center">
     <nav className="navbar navbar-expand gap-3">
      {/* <div className="user-box dropdown px-3">
       <div className="d-flex align-items-center gap-3  d-flex bg-transparent border-0">
        <div className="d-flex user-info text-start justify-content-between">
         <div className="input-group input-group-sm position-relative">
          <span className="input-group-text">Language vitrina:</span>
          <button
           className="btn btn-outline-secondary dropdown-toggle "
           onClick={handleShowCategories}
          >
           {categoryPost}
          </button>
          <ul
           className={"dropdown-menu w-50 " + (isShowCategory && "show")}
           style={{
            transform: isShowCategory
             ? "translate(34px,40px) !important"
             : "null",
           }}
          >
           <li
            className="dropdown-item"
            onClick={(e) => handleChooseCategories(e)}
           >
            EN
           </li>
           <li
            className="dropdown-item"
            onClick={(e) => handleChooseCategories(e)}
           >
            RU
           </li>
          </ul>
         </div>
        </div>
       </div>
      </div> */}
      <div className="user-box dropdown px-3">
       <div className="d-flex align-items-center gap-3  d-flex bg-transparent border-0">
        <div className="user-info text-start">
         <p className="user-name mb-0">{user.username}</p>
         <p className="designattion mb-0 text-start">{user.role}</p>
        </div>
       </div>
      </div>
     </nav>
    </div>
   </div>
  </header>
 );
};

export default observer(Header);
